import { useEditor } from "@smartfire/js-block-engine";
import { useRef, useMemo, useCallback } from "react";
import { useHorizontalScroll, useIntersect } from "../../../hooks";
import clsx from "clsx";
import style from "./style.module.scss";

function TopCategoryMenu({ topCategoryMenu }) {
  const { isEditing } = useEditor();
  const arrowLeftRef = useRef();
  const arrowRightRef = useRef();
  const targetLeftRef = useRef();
  const targetRightRef = useRef();
  const scrollableDivRef = useRef();
  const { startScrolling } = useHorizontalScroll(scrollableDivRef);

  const ratio = useMemo(() => 0.9, []);

  const callbackIntersect = useCallback(
    (entry, ref) => {
      if (entry.intersectionRatio >= ratio) {
        ref.current.classList.add(style.hide);
      } else {
        ref.current.classList.remove(style.hide);
      }
    },
    [ratio]
  );
  const callbackIntersectLeft = useCallback(
    (entry) => callbackIntersect(entry, arrowLeftRef),
    [arrowLeftRef, callbackIntersect]
  );
  const callbackIntersectRight = useCallback(
    (entry) => callbackIntersect(entry, arrowRightRef),
    [arrowRightRef, callbackIntersect]
  );

  useIntersect(targetLeftRef, callbackIntersectLeft, ratio);
  useIntersect(targetRightRef, callbackIntersectRight, ratio);

  return (
    <div className={style.topCatMenu}>
      {!isEditing && (
        <div
          ref={arrowLeftRef}
          className={clsx(style.scrollArrow, style.arrowLeft)}
          onMouseDown={() => startScrolling("left")}
          onTouchStart={() => startScrolling("left")}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 18L15 12L9 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}

      <div className={style.scrollContainer} ref={scrollableDivRef}>
        <div className={style.overflowContainer}>
          <div
            ref={targetLeftRef}
            className={clsx(style.intersectTarget, style.targetLeft)}
          />
          {Object.entries(topCategoryMenu).map((cat, index) => {
            const elem = cat[1];
            return (
              <a href={elem.url} className={style.category} key={index}>
                {elem.title}
              </a>
            );
          })}
          <div
            ref={targetRightRef}
            className={clsx(style.intersectTarget, style.targetRight)}
          />
        </div>
      </div>

      {!isEditing && (
        <div
          ref={arrowRightRef}
          className={clsx(style.scrollArrow, style.arrowRight)}
          onMouseDown={() => startScrolling("right")}
          onTouchStart={() => startScrolling("right")}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 18L15 12L9 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}
    </div>
  );
}

export default TopCategoryMenu;
